import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('declineMeetingsSelectedCategory', function declineMeetingsSelectedCategory(option) {
    var optionState = getStore().currentState;
    optionState.declineMeetingSelectedCategoryKey = option;
});
//# sourceMappingURL=declineMeetingsSelectedCategory.js.map